import { render, staticRenderFns } from "./BreadCrumb.vue?vue&type=template&id=4085c131&scoped=true&"
import script from "./BreadCrumb.vue?vue&type=script&lang=js&"
export * from "./BreadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumb.vue?vue&type=style&index=0&id=4085c131&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4085c131",
  null
  
)

export default component.exports